import { onCleanup, Show } from "solid-js"
import { createStore } from "solid-js/store"
import { useDialog } from "@opencode-ai/ui/context/dialog"
import { DialogBody, DialogHeader, DialogTitle, DialogV2 } from "@opencode-ai/ui/v2/dialog-v2"
import { useLanguage } from "@/context/language"
import type { CoworkArtifact } from "@/cowork/api"

export function ReportDeleteButton(props: { artifact: CoworkArtifact; onDelete: (artifact: CoworkArtifact) => Promise<void> }) {
  const language = useLanguage()
  const dialog = useDialog()
  const open = () => {
    const artifact = props.artifact
    dialog.show(() => {
      const [state, setState] = createStore({ busy: false, error: false })
      let mounted = true
      onCleanup(() => { mounted = false })
      const confirm = async () => {
        if (state.busy) return
        setState({ busy: true, error: false })
        try {
          await props.onDelete(artifact)
          if (mounted) dialog.close()
        } catch {
          if (mounted) setState("error", true)
        } finally {
          if (mounted) setState("busy", false)
        }
      }
      return <DialogV2 fit><DialogHeader closeLabel={language.t("common.close")}><DialogTitle>{language.t("cowork.pipeline.report.delete")}</DialogTitle></DialogHeader>
        <DialogBody class="p-5">
          <p class="mb-4 break-words text-13-regular">{language.t("cowork.report.workspace.deleteConfirm", { title: artifact.title })}</p>
          <Show when={state.error}><p role="alert" class="mb-3 text-12-regular text-v2-state-fg-danger">{language.t("cowork.report.workspace.deleteError")}</p></Show>
          <div class="flex justify-end gap-2"><button class="report-workspace-action" disabled={state.busy} onClick={() => dialog.close()}>{language.t("common.cancel")}</button>
            <button class="report-workspace-action text-v2-state-fg-danger" disabled={state.busy} aria-busy={state.busy} onClick={() => void confirm()}>{language.t("common.delete")}</button></div>
        </DialogBody>
      </DialogV2>
    })
  }
  return <button type="button" class="report-workspace-action text-v2-state-fg-danger" onClick={open}>{language.t("cowork.pipeline.report.delete")}</button>
}
